module.exports = __webpack_public_path__ + "img/ETC.a3e0264b.png";